var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpecialistStreamlineFlex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-0.645 -0.645 18 18",
    id: "Specialist--Streamline-Flex",
    height: 18,
    width: 18,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n    Specialist Streamline Icon: https://streamlinehq.com\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "specialist--support-agent-practitioner",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.29
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.355 8.9a2.3 2.3 0 1 1 0 -4.6 2.3 2.3 0 0 1 0 4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.0 15.1a5.4 5.4 0 0 1 10.7 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.35 6.9a4.0 4.0 0 0 1 8.0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.35 6.5v1.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.35 6.5v1.7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecialistStreamlineFlex);
export default __webpack_public_path__ + "static/media/Specialist--Streamline-Flex.1c8e10ee3a0b82353ff594afae6ff588.svg";
export { ForwardRef as ReactComponent };